<template>
    <div class="cloturer-recla">
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: "CloturerSollicitation",
        methods: {
            ...mapActions('title', ['setTitle'])
        },
        mounted() {
            this.setTitle('Clôturer une sollicitation')
        }
    }
</script>

<style scoped>

    @import "../assets/icon-list.css";

</style>